import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { getPortraitViewportContainer } from "../../compoment/PortraitStage";
import { Container } from "react-bootstrap";
import UsernameModal from "../../modal/UsernameModal";
import { splitName } from "../../utils";
import { toast } from "react-toastify";
import { updateTicketNamesApi } from "../../services/nameUpdateServices";
import Loader from "../../compoment/ui/Loader";
import {
  getTicketDetailFromStorage,
  setTicketDetailInStorage,
} from "../../utils/ticket";

const MainScreen = () => {
    const navigate = useNavigate();
    const [nameModal, setNameModal] = useState(false);
    const [name, setName] = useState("");
    const [nameErr, setNameErr] = useState("");
    const [wish, setWish] = useState("");
    const [wishErr, setWishErr] = useState("");
    const [loading, setLoading] = useState<boolean>(false);
    const [ticketData, setTicketData] = useState<any>({});

    useEffect(() => {
        const ticket = getTicketDetailFromStorage();
        if (ticket) {
            setTicketData(ticket);
        }
    }, []);


    // Handlers
    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value);
        if (nameErr) setNameErr(""); // clear error on typing
    };

    const handleWisdomChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        if (value.length <= 80) {
            setWish(value);
            if (wishErr) setWishErr("");
        }
    };

    useEffect(() => {
        const navigationState = window.history.state;
        if (ticketData && ticketData?.first_name && ticketData?.last_name) {
            const fullName = `${ticketData?.first_name} ${ticketData?.last_name}`;
            setName(fullName);
            setNameModal(false);
        } else if (navigationState?.userName) {
            setName(navigationState.userName);
            setNameModal(false);
        } else {
            setNameModal(true);
        }
    }, [ticketData, ticketData?.first_name, ticketData?.last_name]);

    // handle username submit
    const handleSubmit = async () => {
        if (!name.trim()) {
            setNameErr("Name field is required.");
            return;
        }
        setNameErr("");
        const { firstName, lastName } = splitName(name);

        if (!ticketData?.id) {
            toast.error("Invalid ticket data.");
            return;
        }

        try {
            setLoading(true);
            const response = await updateTicketNamesApi(ticketData.id, {
                first_name: firstName,
                last_name: lastName || " ",
            });

            if (response?.success) {
                const updatedTicket = {
                    ...ticketData,
                    first_name: firstName,
                    last_name: lastName || " ",
                };
                setTicketDetailInStorage(updatedTicket);
                toast.success("Ticket name updated successfully.");
            } else {
                console.error("Failed to update ticket names:", response?.error);
                toast.error(response?.message || "Error updating ticket names.");
            }
        } catch (error) {
            console.error("Error updating ticket names:", error);
            toast.error("Something went wrong while updating the ticket name.");
        } finally {
            setLoading(false);
            setNameModal(false);
        }
    };

    // handle wish submit
    const handleNext = () => {
        if (!wish.trim()) {
            toast.error("Please enter your wish.");
            return;
        }
        if (wish.length > 80) {
            setWishErr("Wish text cannot exceed 80 characters.");
            return;
        }
        localStorage.setItem('wish', wish)
        navigate("/selected-lantern");
    };

    return (
        <>
            {createPortal(
                <div className="fullScreenGif" />,
                getPortraitViewportContainer() ?? document.body
            )}
            {(loading) && <Loader />}
            <section className="mainSection portraitDevice">
                <div className="reasonSection">
                    <div className="scanCard">
                        <div className="heading">Make a wish</div>
                        <div>
                            <textarea
                                name="wishTxt"
                                id="wishTxt"
                                placeholder="Type here"
                                value={wish}
                                maxLength={80}
                                onChange={handleWisdomChange}
                            />
                            <div className="d-flex justify-content-between">
                                <small className="text-muted">Maximum of 80 characters only.</small>
                                <small className="text-muted">{wish?.length}/80</small>
                            </div>
                        </div>
                        <div className="mt-3">
                            <button className="btnScanNow" onClick={handleNext}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Username Modal */}
            {nameModal && (
                <UsernameModal
                    show={nameModal}
                    onHide={() => setNameModal(false)}
                    handleSubmit={handleSubmit}
                    name={name}
                    setName={setName}
                    nameErr={nameErr}
                    setNameErr={setNameErr}
                    handleChange={handleNameChange}
                />
            )}
        </>
    );
};

export default MainScreen;
